// Tom Select

'use strict';

import * as helper from '../../../../src/js/helpers';

import TomSelect from "tom-select";
import {injcectVirtualStackFrame} from "@babel/core/lib/errors/rewrite-stack-trace";

window.TomSelect = TomSelect;

$ice('[data-select]', select => {
    /* import(/!* webpackChunkName: 'tom-select' *!/ 'tom-select')
         .then(({default: TomSelect}) => {*/
    const userOptions = select.dataset.select ? JSON.parse(select.dataset.select) : {};

    let optionTemplate = select.dataset.optionTemplate,
        itemTemplate = select.dataset.itemTemplate;

    const defaultOptions = {
        maxOptions: null,
        onChange: function () {
            this.wrapper.classList.toggle('is-invalid', !this.isValid);
        },
        /*dropdownParent: 'body',*/
        onDropdownOpen: function () {

            this.control_input.classList.remove('dropdown-input');
            this.control_input.classList.add('form-control');
            this.control_input.placeholder = "Search";

            /*// Get dropdown and control box coordinates
            const dropdownRect = this.dropdown.getBoundingClientRect();
            const controlRect = this.control.getBoundingClientRect();

            // Get viewport height
            const viewportHeight = window.innerHeight || document.documentElement.clientHeight;

            this.dropdown.style.display = 'flex';

            // Calculate if dropdown goes beyond the viewport
            if (dropdownRect.bottom > viewportHeight) {
                // Set dropdown bottom to align with the top of the control box
                this.dropdown.style.bottom = (viewportHeight - controlRect.top) + 'px';
                this.dropdown.style.top = 'auto';

                // Change flex-direction to column-reverse to make input appear at the bottom
                this.dropdown.style.flexDirection = 'column-reverse';
            } else {
                // Reset dropdown bottom to default
                this.dropdown.style.bottom = 'auto';

                // Change flex-direction to column to make input appear at the top
                this.dropdown.style.flexDirection = 'column';
            }*/

        },
        onDropdownClose: function () {
            /*const select = this;
            select.dropdown.style.bottom = 'auto';
            select.dropdown.style.top = 'auto';*/
        },
        plugins: ['dropdown_input'],
    };

    const templateOptions = {
        render: optionTemplate ? {
            option: (data, escape) => {
                return optionTemplate.replace(/\[\[.+?\]\]/g, (match) => {
                    return escape(data[helper.getSubstringBetween(match, '[[', ']]')]);
                });
            },
            item: (data, escape) => {
                return itemTemplate.replace(/\[\[.+?\]\]/g, (match) => {
                    return escape(data[helper.getSubstringBetween(match, '[[', ']]')]);
                });
            }
        } : null
    }

    let options = {
        ...defaultOptions,
        ...templateOptions,
        ...userOptions
    };

    if (typeof options.load === 'string') {
        let url = options.load;
        if (url.includes('?')) {
            url += '&q=';
        } else {
            url += '?q=';
        }
        options.load = function (query, callback) {
            fetch(url + encodeURIComponent(query))
                .then(response => response.json())
                .then(data => {
                    callback(data);
                })
                .catch(() => {
                    callback();
                });
        };
    }

    if (select.dataset.escape === 'false') {
        options.render = {
            option: (data, escape) => {
                return '<div>' + (data.text) + '</div>';
            },
            item: (data, escape) => {
                return '<div>' + (data.text) + '</div>';
            }
        };
    }

    let selectEl = new TomSelect(select, options);
    selectEl.getValueData = function () {
        const value = selectEl.getValue();
        if (!value) {
            return {};
        }
        const option = selectEl.options[value];
        if (!option) {
            return {};
        }
        if (typeof option.data === "object") {
            return option.data;
        }
        return {};
    };

    if (select.getAttribute('style')) {
        selectEl.wrapper.setAttribute('style', select.getAttribute('style'));
    }

    const form = select.closest('form.needs-validation');

    if (form) {
        form.addEventListener('submit', (e) => {
            selectEl.wrapper.classList.toggle('is-invalid', !selectEl.isValid);

            if (!form.checkValidity()) {
                e.preventDefault()
                e.stopPropagation()
            }

            form.classList.add('was-validated');
        }, false);
    }
    //window.TomSelect = TomSelect;
    /*})
    .catch(console.warn);*/
});

